import useEvent from 'common/src/hooks/useEvent';
import * as authService from 'common/src/modules/auth/auth.service';
import {UserAuthInfo} from 'common/src/modules/auth/auth.types';
import {Routes} from 'common/src/modules/routing/routing.config';
import {CLRoute} from 'common/src/modules/routing/routing.types';
import {useState} from 'react';
import CLLocalStorage from '../../localStorage/CLLocalStorage';
import {LS_KEY__LOGIN_RETURN_URL} from '../../localStorage/CLLocalStorage.consts';

interface AuthState {
  clientId?: number;
  token?: string;
}

export default function useAuth() {
  const [authState, setAuthState] = useState<AuthState>(authService.getUserAuth());

  const setClientId = useEvent((clientId: number) => {
    authService.setClientId(clientId ?? null);

    setAuthState((prevState: AuthState) => ({
      ...prevState,
      clientId,
    }));
  });

  const setUserAuth = useEvent(({clientId, token, clientIds}: UserAuthInfo) => {
    setAuthState((prevState: AuthState) => {
      const newClientId =
        prevState?.clientId && clientIds.includes(prevState.clientId)
          ? prevState.clientId
          : clientId;
      authService.setUserAuth({clientId: newClientId, token});

      return {
        ...prevState,
        clientId: newClientId,
        token,
      };
    });
  });

  const setToken = useEvent((token: string) => {
    authService.setToken(token);
  });

  const navigateAfterLogin = useEvent(() => {
    const returnUrl = CLLocalStorage.get(LS_KEY__LOGIN_RETURN_URL) as CLRoute;
    CLLocalStorage.remove(LS_KEY__LOGIN_RETURN_URL);
    window.location.href = returnUrl ?? Routes.BaseRoute;
  });

  const signOutUser = useEvent(() => {
    authService.signOutUser();
  });

  return {
    clientId: authState.clientId,
    setClientId,
    get isLoggedIn() {
      return authService.isLoggedIn();
    },
    signOutUser,
    setUserAuth,
    setToken,
    navigateAfterLogin,
  };
}
